export default __webpack_public_path__ + "static/media/Law.75c92731.png";